export default __webpack_public_path__ + "static/media/restaurant-large.b95d2c8d.svg";